import styled from "styled-components";

export const NoticeTextArea = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

export const NoticeBoldText = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  color: #333;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  /* line-height: 12px; */
  line-height: 16px;
`;

export const NotiveSubText = styled.div`
  color: #888;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 100% */

  display: flex;
  align-items: center;

  word-break: keep-all;
`;
